<template>
  <div class="victory">
    <div class="close" @click="close()">
      <p>❌</p>
    </div>
    <img src="../../assets/Gipsy/success.png" class="victory-image" />
    <div class="footer">
      <div class="final-info">
        <p>Temps : {{ duration }} minutes</p>
        <p>Indices : {{ hintsNumber }}</p>
      </div>
      <button @click="goLanding()">Retour au menu principal</button>

      <img src="../../assets/logo.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  props: { startTime: Number, hints: Number, userName: String },
  data() {
    return {
      start: this.startTime,
      hintsNumber: this.hints,
      user: this.userName
    };
  },
  methods: {
    goLanding() {
      window.open("https://mystery-and-lock.fr/", "_blank");
    },
    close() {
      this.$emit("update", false);
    }
  },
  computed: {
    duration() {
      const diff = Math.abs(new Date() - this.start);
      return Math.floor(diff / 1000 / 60);
    }
  },
  created() {
    const diff = Math.abs(new Date() - this.start);
    console.log("duration", Math.floor(diff / 1000 / 60));

    this.$http
      .post("https://mystery-engine.herokuapp.com/api/new", {
        game_log: {
          name: this.user,
          duration: Math.floor(diff / 1000 / 60),
          enigme: "lestrade",
          status: "finish",
          hint: this.hintsNumber
        }
      })
      .then(
        function(response) {
          // Success
          console.log("session finished", response.data);
        },
        function(response) {
          // Error
          console.log(response.data);
        }
      );
  }
};
</script>

<style scoped>
.victory {
  position: absolute;
  color: rgb(35, 35, 35);
  height: 100%;
  width: 100%;
  background: rgba(30, 30, 30, 0.7);
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  font-family: sans-serif;
}
.victory-container {
  width: 50%;
  margin: 0 25%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.victory-image {
  position: absolute;
  height: 90%;
  margin-bottom: 3%;
  margin-top: 3%;
}
.footer {
  position: absolute;
  bottom: 8%;
  display: flex;
  justify-content: space-between;
  width: 65vh;
}
.final-info {
  text-align: left;
}
.footer button {
  background-color: rgba(1, 1, 1, 0);
  color: rgb(10, 10, 10);
  font-family: sans-serif;
  font-size: 100%;
  border: 6px solid rgb(10, 10, 10);
  height: 60px;
  margin-top: 2%;
  border-radius: 10%;
}
.footer button:hover {
  cursor: pointer;
  box-shadow: 0 0 5px 5px rgb(100, 100, 100);
}

.footer img {
  width: 20%;
}
.close {
  position: fixed;
  top: 1%;
  right: 2%;
  z-index: 300;
}
.close:hover {
  cursor: pointer;
}
</style>
